<template>
<div class="new-user">
    <div class="container">
        <ol class="breadcrumbs">
            <router-link to="/dashboard">Dashboard</router-link>
            <span v-if="!orgUrl"> > <router-link to="/users">Users</router-link></span>
            <span v-if="!userId"> > New User</span>
            <span v-if="userId"> > Edit User</span>
        </ol>
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800" v-if="!userId && !orgUrl">Add New Admin</h1>
            <h1 class="h3 mb-0 text-gray-800" v-if="!userId && orgUrl">Add New {{org.name}} User</h1>
            <h1 class="h3 mb-0 text-gray-800" v-if="userObj && userObj.name">Edit {{userObj.name}}</h1>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-body">
                        <div v-if="error" class="alert alert-danger">{{error}}</div>
                        <div v-if="success" class="alert alert-success">{{success}}</div>
                        <form action="#" @submit.prevent="submit">
                            <div class="mt-4 form-group row">
                                <label for="name" class="col-md-4 col-form-label text-md-right">Full Name</label>

                                <div class="col-md-4">
                                    <input id="name" type="name" class="form-control" name="name" value required autofocus v-model="userObj.name" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">Email/Username</label>

                                <div class="col-md-6">
                                    <input id="email" :disabled="userId" type="email" class="form-control" name="email" value required autofocus v-model="userObj.email" />
                                </div>
                            </div>

                            <div class="form-group row" v-if="!userId">
                                <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

                                <div class="col-md-4">
                                    <input id="password" required minlength="6" type="text" class="form-control" name="password" v-model="form.password" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">Phone</label>

                                <div class="col-md-3">
                                    <input id="phone" required type="tel" class="form-control" name="phone" autofocus v-model="userObj.phone" />
                                </div>
                            </div>

                            <div class="form-group row" v-if="orgUrl || userObj.organisation">
                                <label for="email" class="col-md-4 col-form-label text-md-right">Organisation</label>

                                <div class="col-md-4">
                                    <select :disabled="org" required v-model="userObj.organisation" name="dataTable_length" aria-controls="dataTable" class="custom-select form-control form-control-sm">
                                        <option value="">--Select Organisation if Available--</option>
                                        <option :value="org['.key']" v-for="(org, i) in orgs" v-bind:key="i">{{org.name}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row" v-if="user && user.data && user.data.role > 10 && !org || !userObj.organisation">
                                <label for="email" class="col-md-4 col-form-label text-md-right">Permission Level</label>

                                <div class="col-md-4">
                                    <select required v-model="userObj.role" name="dataTable_length" aria-controls="dataTable" class="custom-select form-control form-control-sm">
                                        <option value="">--Select User Role--</option>
                                        <option :value="2">{{2 | roleName}}</option>
                                        <option :value="6">{{6 | roleName}}</option>
                                        <option :value="8">{{8 | roleName}}</option>
                                        <option :value="10">{{10 | roleName}}</option>
                                        <option :value="12">{{12 | roleName}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row" v-if="userObj.role >= 8">
                                <label for="email" class="col-md-4 col-form-label text-md-right">Colour Indicator</label>

                                <div class="col-md-3">
                                    <input id="phone" type="tel" class="form-control" name="phone" value autofocus v-model="userObj.colour" /><small>Web Colours Options <a target="_blank" href="https://www.w3schools.com/colors/colors_names.asp">here</a> i.e. DarkBlue</small>
                                </div>
                            </div>

                            <div class="form-group row mb-4 mt-4" v-if="user && user.data && user.data.role > 8">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-lg btn-primary">
                                        <span v-if="!userId">Create New User</span>
                                        <span v-if="userId">Update User</span>

                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    db,
    secondaryApp
} from "../main";
import {
    mapGetters
} from "vuex";

//const usersRef = db.ref("users");
import getOrganisation from "../mixins/getOrganisation";

export default {
    name: "NewUser",
    mixins: [getOrganisation],
    computed: {
        ...mapGetters({
            orgs: "orgs",
            user: "user"
        }),
    },
    data() {
        return {
            userObj: {
                name: "",
                email: "",
                phone: "",
                role: "",
                organisationObj: {},
                password: "",
            },
            form: {
                password: "",
            },
            userId: this.$route.params.id,
            success: null,
            error: null
        };
    },
    created() {
        this.$store.dispatch('bindOrgs')
    },
    methods: {
        getOrgFromId() {

        },
        deleteUser() {
            const t = this;
            //Remove From User table
            this.database.ref('users/' + t.userObj['.key']).remove();
            //Remove User
        },
        submit() {
            var t = this;
            t.success = null;
            t.error = null;
            //secondary Auth object hack so as userObj isnt logged into new account
            if (!t.userObj.created) {
                secondaryApp.auth()
                    .createUserWithEmailAndPassword(t.userObj.email, t.form.password)
                    .then((data) => {
                        console.log('login', data);
                        secondaryApp.auth().signOut();
                        db.ref("users/" + data.user.uid).set({
                                name: t.userObj.name,
                                email: t.userObj.email,
                                phone: t.userObj.phone,
                                //organisation: t.userObj.organisationObj['.key'],
                                //organisationName: t.userObj.organisationObj.name,
                                role: t.userObj.role,
                                created: (new Date()).toISOString(),
                            },
                            function (error) {
                                if (error) {
                                    // The write failed...
                                    t.error = error;
                                } else {
                                    t.success = "New User Created Successfully ";

                                    // Data saved successfully!
                                }
                            }
                        );
                    })
                    .catch((error) => {
                        var errorCode = error.code;
                        var errorMessage = error.message;
                        if (errorCode == 'auth/weak-password') {
                            this.error = 'The password is too weak.';
                        } else {
                            this.error = errorMessage;
                        }
                    });
            } else {
                //Update User
                console.log(t.userObj);

                db.ref('users/' + t.userId)
                    .set(t.userObj)
                    .then(() => {
                        console.log('User updated!')
                        t.success = "User Updated";

                    })
            }
        },
    },
    watch: {
        userId: {
            // call it upon creation too
            immediate: true,
            handler(userId) {
                console.log(userId);
                const t = this;
                if (userId) {
                    this.$rtdbBind(
                        "userObj",
                        db.ref("users/" + userId)).then((result) => {
                        console.log('result', result);
                        console.log('result', t.userObj);
                        if (t.userObj.organisation) {
                            t.organisationObj = t.orgs[1]; //= t.orgs.find(item => item['.key'] === t.userObj.organisation);
                            console.log('organisationObj', t.organisationObj);
                        }

                        if (!t.userObj) {
                            this.error = "No results for search by: " + t.email;
                        }

                        //this.jobsRaw === jobsRaw;
                    })
                }
            },
        },
    },
};
</script>
